import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "Bespoke Lending",
  "Property Investment",
  "Wealth Creation",
  "Refinancing",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-black/[0.08] py-10 md:py-14 overflow-hidden plaid"
  >
    <div className="absolute inset-0 bg-[#FBF7F2]/75" aria-hidden="true" />
    <div className="relative">
      <FastMarquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-display italic uppercase font-medium text-4xl md:text-6xl text-[#493E38] mx-12">
              {item}
            </span>
            <span className="text-[#CFAEA5] text-2xl md:text-4xl font-display">—</span>
          </span>
        ))}
      </FastMarquee>
    </div>
  </div>
);
